<!--
 * @Author: Yran
 * @Date: 2021-07-26 10:28:02
 * @LastEditors: chenxing
 * @LastEditTime: 2022-02-24 18:14:35
-->
<template>
  <a-select :autoClearSearchValue	=false :dropdown-class-name="`name_dropdown_wrapper ${showRectangle ? 'rectangle-wrapper' : ''}`" v-if="!isTree" class="select-multiple" :model-value="data.selectValue" v-bind="$attrs" :max-tag-placeholder="maxTagPlaceholder" @focus="onSelectFocus" :filter-option="filterOption">
    <a-select-option v-for="(option, index) in selectOptions" :key="index" :value="option[selectOptionValue]" :label="option[selectOptionLabel]">
      <div class="w100 h100 option-content-wrapper">
        <a-checkbox v-if="$attrs.mode && ($attrs.mode == 'multiple' || $attrs.mode == 'tags')" :checked="getChecked(option[selectOptionValue])"></a-checkbox>
        <div class="option-content">
          <p class="option-label" :title="option[selectOptionLabel]">{{ option[selectOptionLabel] }}</p>
          <p class="option-value" v-if="showKey">{{ showKey }}：{{ option[selectOptionValue] }}</p>
        </div>
      </div>
    </a-select-option>
    <a-select-option disabled class="load_more_wrapper" v-if="lazyLoad && !loadOver" :label="data.inputval" ref="loadingIcon">
      <div style="width: 100%; text-align: center" ref="loadingIcon" id="bottom">正在加载<LoadingOutlined /></div>
    </a-select-option>
    <template #notFoundContent>
      <a-spin v-if="selectLoading" style="width: 100%; padding: 10px 0" />
      <a-empty v-else :image="data.simpleImage">
        <template #description>
          <span>暂无数据</span>
        </template>
      </a-empty>
    </template>
  </a-select>
  <a-tree-select v-else class="select-multiple" :model-value="data.selectValue" v-bind="$attrs" :max-tag-placeholder="maxTagPlaceholder">
    <template #notFoundContent>
      <a-empty :image="data.simpleImage">
        <template #description>
          <span>暂无数据</span>
        </template>
      </a-empty>
    </template>
  </a-tree-select>
</template>
<script>
import aTooltip from 'ant-design-vue/lib/tooltip';
import { Empty } from 'ant-design-vue';
import { ref, reactive, nextTick, h, onMounted } from 'vue';
import { LeftSquareFilled, LoadingOutlined } from '@ant-design/icons-vue';
import _ from 'lodash';
import { LoadMore } from '@/utils/LoadMore.js';
export default {
  components: { LoadingOutlined },
  emits: ['toBottom', 'update:loadOver', 'selectFocus'],
  props: {
    // 已选中选项
    selectData: {
      type: [Array, Number, String],
      default: () => {
        return [];
      },
    },
    // 下拉项数据源
    selectOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 下拉菜单项的value key
    selectOptionValue: {
      type: String,
      default: 'value',
    },
    // 下拉菜单项的label key
    selectOptionLabel: {
      type: String,
      default: 'label',
    },
    // 可选中最大值
    maxLength: {
      type: Number,
      default: 10000,
    },
    isTree: {
      type: Boolean,
      default: false,
    },
    selectLoading: {
      type: Boolean,
      default: false,
    },
    // 是否滚动加载
    lazyLoad: {
      type: Boolean,
      default: false,
    },
    // 滚动加载是否加载完毕
    loadOver: {
      type: Boolean,
      default: false,
    },
    // 矩形排列
    showRectangle: {
      type: Boolean,
      default: false,
    },
    // 展示key值
    showKey: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const data = reactive({
      inputval: '',
      checkedList: [],
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      selectValue: [],
      loadEx: null, //滚动监听示例
      showTooltip: false,
    });
    onMounted(() => {
      if (props.selectData) data.selectValue = props.selectData;
    });
    /**
     * @description: 隐藏 tag 时显示的内容
     * @param {*} omittedValues
     * @return {*}
     */
    const maxTagPlaceholder = omittedValues => {
      let values = '';
      omittedValues?.forEach(item => {
        values += item.label + ';';
      });
      return (
        <aTooltip title={values}>
          <span>+</span>
          <span style={{ margin: '0 5px' }}>{omittedValues.length}</span>
          <span>...</span>
        </aTooltip>
      );
    };

    // 设置滚动加载
    const loadingIcon = ref(); // 引用loadingIcon元素
    // 触底事件
    const toBottom = () => {
      context.emit('toBottom');
    };
    // 初始化触底监听
    const initObserve = () => {
      context.emit('update:loadOver', false);
      nextTick(() => {
        if (props.lazyLoad && !props.loadOver) {
          const rootNodeList = document.querySelectorAll('.name_dropdown_wrapper');
          let rootNode = null;
          rootNodeList.forEach((item, index) => {
            const innerText = item.innerText;
            if (innerText.indexOf('加载')) {
              rootNode = item;
            }
          });
          const obsNode = loadingIcon.value;
          if (rootNode && obsNode) {
            let loadExValue = new LoadMore({
              root: rootNode,
              obs: obsNode,
              loadMoreFn: () => {
                if (props.loadOver) {
                  loadExValue.cancelObserve();
                } else {
                  setTimeout(() => {
                    toBottom();
                  }, 300);
                }
              },
            });
            data.loadEx = loadExValue;
          }
        }
      });
    };
    // select聚焦(聚焦之后才有下拉DOM)
    const onSelectFocus = () => {
      context.emit('selectFocus');
      initObserve();
    };
    // 可根据key和label筛选
    const filterOption = (inputValue, option) => {
      return `${option.value}`.includes(inputValue) || `${option.label}`.includes(inputValue);
    };

    /**
     * @description: 设置复选框
     * @param {*}
     * @return {*}
     */
    const getChecked = value => {
      let returnValue = null;
      if (!value) {
        return false;
      } else if (context.attrs['label-in-value']) {
        returnValue =
          data.selectValue?.findIndex(item => {
            return item[props.selectOptionValue] == value || item.value == value;
          }) > -1;
      } else {
        returnValue =
          data.selectValue?.findIndex(item => {
            return item == value;
          }) > -1;
      }
      return returnValue;
    };

    return {
      data,
      loadingIcon,
      maxTagPlaceholder,
      onSelectFocus,
      getChecked,
      filterOption,
      initObserve,
    };
  },
  watch: {
    selectData: {
      handler(newVal) {
        if (newVal) this.data.selectValue = newVal;
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.name_dropdown_wrapper {
  .option-content-wrapper {
    display: inline-flex;
    .ant-checkbox-wrapper {
      margin-right: 5px;
    }
    .option-content {
      // width: 50px;
      flex-grow: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      & > p {
        width: 100%;
        white-space: nowrap;
        line-height: 14px;
      }
      .option-value {
        color: #b7b7b7;
        size: 12px;
      }
    }
  }
}
.ant-select-item-option-state {
  display: none;
}
.ant-select-item-option-content {
  text-align: left;
}
.ant-select-tree-node-content-wrapper {
  text-align: left;
}
.rectangle-wrapper {
  .rc-virtual-list-holder-inner {
    flex-wrap: wrap;
    flex-direction: row !important;
    max-width: 640px;
    .ant-select-item.ant-select-item-option {
      width: 150px;
      margin-right: 10px;
    }
  }
}
</style>